import React from 'react';
import SMReservationBaseView from 'components/dashboard/shared/SMReservationBaseView';
import SMConst from 'lib/SMConst';
import SMReservationHeaderView from 'components/dashboard/shared/SMReservationHeaderView';
import SMReservationNoticeView from 'components/dashboard/shared/SMReservationNoticeView';
import SMReservationFlowView from 'components/dashboard/shared/SMReservationFlowView';
import SMBillingList from 'components/dashboard/shared/SMBillingList';
import SMGuestList from 'components/dashboard/shared/SMGuestList';
import SMOReservationActionView from './SMOReservationActionView';
import SMReputationFormView from 'components/dashboard/shared/SMReputationFormView';
import sprintf from 'sprintf';
import SMOReservationConfirmView from './SMOReservationConfirmView';
import SMOReservationCancelView from './SMOReservationCancelView';
import SMOReservationRefundView from './SMOReservationRefundView';
import SMOReservationRejectView from './SMOReservationRejectView';
import Spinner from 'components/shared/SMMaterialSpinner';
import SMUnapprovedReservationConfirmView from 'components/dashboard/shared/SMUnapprovedReservationConfirmView';
import SMUnapprovedReservationRejectView from 'components/dashboard/shared/SMUnapprovedReservationRejectView';
import SMOReservationUnapprovedView from 'components/dashboard/owners/reservations/SMOReservationUnapprovedView';
import SMOReservationInviteView from 'components/dashboard/owners/reservations/SMOReservationInviteView';
import SMReservationStatusDescriptionView from 'components/dashboard/shared/SMReservationStatusDescriptionView';

class SMOReservationView extends SMReservationBaseView {

  constructor(props) {
    super(props);
    this.state['isUnapprovedViewOpen'] = true;
  }

  confirmActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOReservationConfirmView reservation={this.props.reservation} delegate={this} />
    );
  }

  inviteActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOReservationInviteView reservation={this.props.reservation} delegate={this} />
    );
  }

  dismissCancelModalView(e) {
    e.preventDefault();
  }

  rejectActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOReservationRejectView reservation={this.props.reservation} delegate={this} />
    );

  }

  cancelActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOReservationCancelView reservation={this.props.reservation} delegate={this} />
    );
  }

  refundActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOReservationRefundView reservation={this.props.reservation} delegate={this} />
    );
  }

  reservationDidConfirm(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.reservationDidConfirm === 'function'){
      this.props.delegate.reservationDidConfirm(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  reservationDidFailToConfirm(error, xhr) {
    if(this.props.delegate && typeof this.props.delegate.reservationDidFailToConfirm === 'function'){
      this.props.delegate.reservationDidFailToConfirm(error, xhr);
    }
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
  }

  reservationDidReject(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.reservationDidReject === 'function'){
      this.props.delegate.reservationDidReject(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  reservationDidFailToReject(error, xhr) {
    if(this.props.delegate && typeof this.props.delegate.reservationDidFailToReject === 'function'){
      this.props.delegate.reservationDidFailToReject(error, xhr);
    }
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
  }

  reservationDidCancel(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.reservationDidCancel === 'function'){
      this.props.delegate.reservationDidCancel(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  reservationDidFailToCancel(error, xhr) {
    if(this.props.delegate && typeof this.props.delegate.reservationDidFailToCancel === 'function'){
      this.props.delegate.reservationDidFailToCancel(error, xhr);
    }
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
  }

  confirmUnapprovedReservationActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMUnapprovedReservationConfirmView
        reservation={this.props.reservation}
        isOwner={true}
        delegate={this}
      />
    );
  }

  rejectUnapprovedReservationActionDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMUnapprovedReservationRejectView
        reservation={this.props.reservation}
        isOwner={true}
        delegate={this}
      />
    );
  }

  reservationDidRefund(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.reservationDidRefund === 'function'){
      this.props.delegate.reservationDidRefund(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  reservationDidFailToRefund(error, xhr) {
    if(this.props.delegate && typeof this.props.delegate.reservationDidFailToRefund === 'function'){
      this.props.delegate.reservationDidFailToRefund(error, xhr);
    }
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
  }

  unapprovedReservationDidConfirm(data, xhr) {
    this.hideDialog();
    if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidConfirm == 'function') {
      this.props.delegate.unapprovedReservationDidConfirm(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000008"));
  }

  unapprovedReservationDidFailToConfirm(error, xhr) {
    this.hideDialog();
    if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToConfirm == 'function') {
      this.props.delegate.unapprovedReservationDidFailToConfirm(error, xhr);
    }
    if (xhr.responseJSON.message) {
      $("#js-split_view-main").showFailMessage(xhr.responseJSON.message.replace(/\\n/g, '<br />'));
    } else {
      $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
    }
    this.setState({isUnapprovedViewOpen: false});
  }

  unapprovedReservationDidReject(data, xhr) {
    this.hideDialog();
    if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidReject == 'function') {
      this.props.delegate.unapprovedReservationDidReject(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000009"));
  }

  unapprovedReservationDidFailToReject(error, xhr) {
    if (this.props.delegate && typeof this.props.delegate.unapprovedReservationDidFailToReject == 'function') {
      this.props.delegate.unapprovedReservationDidFailToReject(error, xhr);
    }
    if (xhr.responseJSON.message) {
      $("#js-split_view-main").showFailMessage(xhr.responseJSON.message);
    } else {
      $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
    }
    this.setState({isUnapprovedViewOpen: false});
  }

  /* Render */

  renderInit (){
    return (
      <p className="dashboard-maincol__message">{I18n.t("dashboard.text_000014")}</p>
    );
  }

  renderUnapprovedView (reservation){
    if (!reservation.unapproved_reservation_from_user || !this.state.isUnapprovedViewOpen) return null;
    return (
      <SMOReservationUnapprovedView
        reservation={reservation}
        unapproved_reservation={reservation.unapproved_reservation_from_user}
        delegate={this} />
    );
  }

  renderDefault (){
    let reservation = this.props.reservation;
    let billingList = [];
    if (reservation.billing) {
      billingList.push(
        <h2 key={reservation.id + "-title"} className="dashboard-title mb20 mt50">{I18n.t("dashboard.label_000132")}</h2>
      );
      billingList.push(
        <SMBillingList key={reservation.id} reservation={reservation} isOwner={true} />
      );
    }

    let guestList = [];
    if (reservation.number_of_guests > 0 && reservation.rent_type == SMConst.RentType.Stay && reservation.room.stay_certification_type == SMConst.StayCertificationType.VacationRental ) {
      guestList.push(
        <h2 key={reservation.id + "-title"} className="dashboard-title mb20 mt50">{I18n.t("dashboard.label_000601")}</h2>
      );
      guestList.push(
        <p key={reservation.id + "-notice"} className="dashboard-content mb15" dangerouslySetInnerHTML={{__html: I18n.t('dashboard.text_000600_html') }} />
      );
      guestList.push(
        <SMGuestList key={reservation.id} reservation={reservation} delegate={this} />
      );
    }

    if (reservation.mediator == SMConst.ReservationMediator.SpaceMarket) {
      let reviewTitleStyle = (reservation.method != SMConst.ReservationMethod.Reservation) ? {display: "none"} : {};
      return (
        <div>
          {this.renderUnapprovedView(reservation)}
          <SMReservationHeaderView
            isOwner={true}
            reservation={reservation} />
          <SMReservationNoticeView isOwner={true} reservation={reservation} />
          <h2 className="dashboard-title mb20 mt40">{I18n.t("dashboard.label_000133")}</h2>
          <SMReservationFlowView reservation={reservation} isOwner={true} />
          <SMOReservationActionView reservation={reservation} delegate={this} />
          <SMReservationStatusDescriptionView reservation={reservation} isOwner={true} />
          {billingList}
          {guestList}
          <h2 ref="reviewTop" style={reviewTitleStyle} className="dashboard-title mb20 mt50">{I18n.t("dashboard.label_000134")}</h2>
          <SMReputationFormView reservation={reservation} isOwner={true} />
        </div>
      );
    } else {
      return (
        <div>
          <SMReservationHeaderView
            isOwner={true}
            reservation={reservation} />
          <h2 className="dashboard-title mb20 mt40">{I18n.t("dashboard.label_000133")}</h2>
          <SMReservationFlowView reservation={reservation} isOwner={true} />

          <h2 className="dashboard-title mb20 mt40">お客様情報</h2>
          <div className="reserve-detail-box">
            <p className="fl w500">電話番号</p>
            <p className="fr">{reservation.user.tel}</p>
          </div>
          <div className="reserve-detail-box">
            <p className="fl w500">メールアドレス</p>
            <p className="fr">{reservation.user.email}</p>
          </div>
          <div className="reserve-detail-box">
            <p className="fl w500">メモ</p>
            <p className="fr">{reservation.note}</p>
          </div>
          <div className="reserve-detail-box">
            <p className="fl w500">受付</p>
            <p className="fr">{reservation.channel_type_text}</p>
          </div>
          {billingList}
          {guestList}
        </div>
      );
    }
  }

  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }

  render() {
    if (!this.props.isCurrentView) return null;
    return (
      <div className="reserve-maincol__right-inner js-scroller" ref="scroller">
        {(()=>{
          switch (this.state.display) {
            case SMConst.Display.Hidden: return null;
            case SMConst.Display.Init: return this.renderInit();
            case SMConst.Display.Loading: return this.renderLoading();
            default: return this.renderDefault();
          }
        })()}
      </div>
    );
  }
}
SMOReservationView.defaultProps = {
  display: SMConst.Display.Visible,
  page: 1,
  perPage: 20,
  shouldShowReview: false,
};
export default SMOReservationView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationView.jsx